import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Link} from '../';

const Menu = (props) => {
  const {delimiter, theme, links, template, activeItem} = props;
  const classes = classNames({
    menu: true,
    menu_delimiter: Boolean(delimiter),
    [`menu_${theme}`]: Boolean(theme),
  });

  const renderNavItem = (navItem) => {
    if (navItem.disabled) {
      return false;
    }

    let linkColor = '#666666';

    if (theme === 'main') {
      linkColor = navItem.link === activeItem ? template.primaryColor : template.secondaryColor;
    }

    return (
      <li key={navItem.text} className="menu-item">
        <Link
          color={linkColor}
          className="link"
          panelMethod={navItem.panelMethod}
          renderInPanel={navItem.renderInPanel}
          renderInFooter={navItem.renderInFooter}
          to={navItem.link || '#'}
          text={navItem.text}
        />
      </li>
    );
  };

  return (
    <ul className={classes}>
      {links.map(link => renderNavItem(link))}
    </ul>
  );
};

Menu.propTypes = {
  delimiter: PropTypes.bool,
  theme: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  template: PropTypes.shape({}),
  activeItem: PropTypes.string,
};

Menu.defaultProps = {
  delimiter: false,
  theme: '',
  template: {},
  activeItem: '',
};

export default Menu;
